module.exports = __webpack_public_path__ + "img/home-img-6.51d35783.webp";